import { useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { IsAccountClosableDocument } from './isAccountClosable.gql';

const useIsAccountClosable = () => {
  const { companyProfileId } = useCompanyContext();

  const { data, error, loading } = useQuery(IsAccountClosableDocument, {
    variables: { companyProfileId: companyProfileId as string },
  });

  const ineligibilityReasons = new Set(
    data?.isAccountClosable ? data.isAccountClosable.ineligibilityReasons : [],
  );

  return {
    error,
    ineligibilityReasons,
    isClosable: !loading && data?.isAccountClosable.isClosable,
    loading,
  };
};

export default useIsAccountClosable;
